import {
    SEND_CAREERS_EMAIL,
    SEND_CAREERS_EMAIL_FAILURE,
    SEND_CAREERS_EMAIL_SUCCESS
} from '../actionTypes';

const initialState = {
    isLoading: false
};

const careersReducer = (state = initialState, action) => {
    const { type } = action;

    switch (type) {
        case SEND_CAREERS_EMAIL:
            return {
                isLoading: true
            };
        case SEND_CAREERS_EMAIL_SUCCESS: {
            return {
                isLoading: false
            };
        }
        case SEND_CAREERS_EMAIL_FAILURE:
            return {
                isLoading: false
            };
        default:
            return state;
    }
};

export default careersReducer;
